/** Shared helpers for RAID dialog forms (partial RAID defaults, dates). */

export function getIsoDate(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Expected completion default: 7 days from entry date. */
export function getDefaultExpectedDate(from: Date = new Date()): string {
  const d = new Date(from);
  d.setDate(d.getDate() + 7);
  return getIsoDate(d);
}

export interface PartialRaidCommonProps {
  /** When true, only title/description/assignee (+ defaults) are required. */
  partialRaid?: boolean;
  /** Review entity owner user id — used as default Assigned To for partial RAID. */
  defaultAssigneeId?: string | number | null;
  /** Existing partial_raid flag when editing. */
  initialPartialRaid?: boolean;
}
